import React, { useMemo } from 'react'
/** @type {React.FC<{ errors: Record<string, string[]>; errorKeys: string[] }>} */
export const ErrorComponent = (props) => {
  const { errors = {}, errorKeys = [] } = props

  const messages = useMemo(
    () => (errorKeys.length === 0 ? Object.values(errors).flat() : errorKeys.map((e) => errors?.[e] || []).flat()),
    [errors, errorKeys]
  )

  return (
    <>
      {messages.map((e, index) => {
        return (
          <p className="red--text" key={index}>
            {e}
          </p>
        )
      })}
    </>
  )
}
